// extracted by mini-css-extract-plugin
export default {"startPageSection":"startPageSection--nzKs5"};